import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import BottomNav from "../components/BottomNav";
import AddressSheet from "../components/AddressSheet";
import { useLocale } from "../context/Locale";
import { api } from "../lib/api";

const fallbackServices = [
  { id: "POINT_TO_POINT", name: "Recojo y entrega", description: "", enabled: false },
  { id: "TAXI", name: "Taxi", description: "", enabled: false },
];

export default function ServicesPage() {
  const { t } = useLocale();
  const [services, setServices] = useState(fallbackServices);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api("/service-hub")
      .then((data) => {
        if (active && Array.isArray(data?.services)) setServices(data.services);
      })
      .catch(() => {})
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <main className="food-app">
      <AppHeader />
      <div className="food-app__content services-page">
        <header className="services-page__heading">
          <small>DELIVERY HUARAZ</small>
          <h1>{t("servicesTitle")}</h1>
          <p>{t("servicesHelp")}</p>
        </header>

        {loading ? (
          <div className="explore-loading"><i /><span>{t("loadingServices")}</span></div>
        ) : (
          <section className="services-page__grid">
            {services.map((service) => {
              const target = `/services/${String(service.id).toLowerCase()}`;
              const content = (
                <>
                  <span className="services-page__icon" aria-hidden="true">
                    {service.id === "TAXI" ? "🚕" : "📦"}
                  </span>
                  <div>
                    <small>{service.enabled ? t("available") : t("temporarilyUnavailable")}</small>
                    <h2>{service.name}</h2>
                    <p>{service.enabled ? service.description : service.unavailable_message}</p>
                    <b>{service.enabled ? `${t("enterService")} →` : t("closedNow")}</b>
                  </div>
                </>
              );
              return service.enabled ? (
                <Link className="services-page__card" to={target} key={service.id}>{content}</Link>
              ) : (
                <article className="services-page__card is-disabled" key={service.id}>{content}</article>
              );
            })}
          </section>
        )}
      </div>
      <BottomNav />
      <AddressSheet />
    </main>
  );
}
